import axios from 'axios';

import Util from '../util';

const apiUrl = process.env.REACT_APP_API_URL;

const ScheduleAPI = {
  /**
   * Get schedules for current organization
   * @param {object} cancelToken - Token axios
   * @returns {object} schedules of current organization
   */
  getSchedules: async (cancelToken) => {
    const res = await Util.catch418And403Error(
      axios.get,
      `${apiUrl}/schedule/schedules`,
      Util.apiGetCallSettings(cancelToken),
    );

    return res.data.schedules;
  },

  /**
   * Get waterfall schedules for current organization
   * @param {object} cancelToken - Token axios
   * @returns {object} waterfall schedules of current organization
   */
  getWaterfallSchedules: async (cancelToken) => {
    const res = await Util.catch418And403Error(
      axios.get,
      `${apiUrl}/schedule/waterfall-schedules`,
      Util.apiGetCallSettings(cancelToken),
    );

    return res.data.schedules;
  },
};

export default ScheduleAPI;
